<template>
    <a v-if="type === 'default'" :href="to" :class="{'btn-inverted' : inverted}" class="btn">
        <slot v-if="icon === ''"/>
        <span v-else>
            <slot/>
        </span>
        <Icon v-if="icon !== ''" :name="icon"/>
    </a>
    <a v-else-if="type === &quot;stroke&quot;" :href="to" :class="{'btn-inverted' : inverted}" class="btn btn-stroke">
        <slot v-if="icon === ''"/>
        <span v-else>
            <slot/>
        </span>
        <Icon v-if="icon !== ''" :name="icon"/>
    </a>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'default'
        },
        icon: {
            type: String,
            default: ''
        },
        inverted: {
            type: Boolean,
            default: false
        },
        to: {
            type: String,
            required: true
        }
    }
};
</script>
